/* Motion lifecycle: native scrolling, no offscreen animation/video work. */
(()=>{'use strict';
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const scopes=[...document.querySelectorAll('.premium-scene,.marquee')],intersections=new Map();
 const hero=document.querySelector('.hero'),video=document.querySelector('#hero-video');
 let modal=null,queued=false,lastHeroPlay=false;
 const paused=()=>document.body.classList.contains('paused')||reduced.matches;
 function canAnimate(element){
  if(document.hidden||paused())return false;
  const dialog=element.closest('dialog');
  if(dialog)return dialog.open&&!element.closest('[hidden]');
  if(modal)return false;
  const scope=element.closest('.premium-scene,.marquee');
  return !scope||intersections.get(scope)===true;
 }
 function syncVideo(){
  if(!video)return;
  const source=video.querySelector('source');
  const pilot=document.querySelector('[data-pilot-video]');
  const shouldPlay=canAnimate(hero)&&!(pilot&&!pilot.paused)&&!!(source?.getAttribute('src')||source?.dataset.src);
  if(shouldPlay){
   if(!source.getAttribute('src')){source.src=source.dataset.src;video.load();}
   if(!lastHeroPlay||video.paused)video.play().catch(()=>{});
  }else if(!video.paused)video.pause();
  lastHeroPlay=shouldPlay;
 }
 function refresh(){
  queued=false;modal=document.querySelector('dialog[open]');
  document.body.classList.toggle('modal-active',!!modal);
  document.body.classList.toggle('page-hidden',document.hidden);
  for(const scope of scopes){const active=String(canAnimate(scope));if(scope.dataset.motionActive!==active)scope.dataset.motionActive=active;}
  syncVideo();document.dispatchEvent(new CustomEvent('umbral:motion-state'));
 }
 function schedule(){if(!queued){queued=true;queueMicrotask(refresh);}}
 window.UmbralMotion={canAnimate,syncVideo:schedule};
 const observer=new IntersectionObserver(entries=>{for(const entry of entries)intersections.set(entry.target,entry.isIntersecting);schedule();},{rootMargin:'0px',threshold:0});
 for(const scope of scopes){intersections.set(scope,false);scope.dataset.motionActive='false';observer.observe(scope);}
 for(const dialog of document.querySelectorAll('dialog'))new MutationObserver(schedule).observe(dialog,{attributes:true,attributeFilter:['open']});
 // Watch only the relevant class value to avoid feedback from our own lifecycle flags.
 let pauseState=paused();new MutationObserver(()=>{const next=paused();if(next!==pauseState){pauseState=next;schedule();}}).observe(document.body,{attributes:true,attributeFilter:['class']});
 document.addEventListener('visibilitychange',schedule);reduced.addEventListener('change',schedule);
 refresh();
})();
